import React from "react";
import { Stack } from "@mui/system";
import { Helmet } from "react-helmet-async";

import TitleProject from "../Components/Title";
import Ouvidoria from "../../../components/Ouvidoria";

import './style.scss';
import Galery from "./galery";

export default function S11D(){

  return(

    <>
    <Helmet title="Projeto S11D - Séculos Engenharia e Serviços LTDA" />
    <TitleProject name="PROJETO S11D" link1={"Projetos/ "} link2={"PROJETO S11D"} />
      <section id="context">
        <div className="container">

        <div>
          <Stack
            direction={{xs: 'column', sm: 'row'}}
            spacing={{xs: 1, sm: 2, md: 4}}
            className="context-desc"
          >
            <div className="context-box">
              <div className="context-desc-inside">
                <h2
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">
                    Projeto S11D
                </h2>
                <p
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">
                 Prestação de serviços técnicos especializados de topografia em estruturas metálicas e civis, compreendendo os equipamentos da usina e mina do complexo S11D Eliezer Batista em Canaã dos Carajás – PA.
                </p>
              </div>
            </div>

            <div className="context-box context-info"
              data-aos="fade-zoom-in" 
              data-aos-duration="1000"
              data-aos-delay="300"
              data-aos-offse="0"
            >
                <h2>Informações do Projeto</h2>
                <ul>
                  <li><strong>Cliente: </strong> Vale</li>
                  <li><strong>Cidade: </strong> Canaã dos Carajás - PA </li>
                  <li><strong>Ano: </strong> 2020 </li>
                  <li><strong>Segmento: </strong> Topografia </li>
                </ul>
            </div>

          </Stack>
        </div>
        </div>
      </section>

      <Galery />

      <Ouvidoria/>
    </>
  )
}